export function intersect<T>(first: T[], second: T[]) {
  const commonElements = first.filter((value) => second.includes(value));
  const removedDuplicates = commonElements.filter(
    (element, pos, self) => self.indexOf(element) === pos
  );
  return removedDuplicates;
}
